// everyday-art-grid.js
document.addEventListener('DOMContentLoaded', () => {
  // 1) per-card logic
  document.querySelectorAll('.eag-item').forEach(item => {
    const form    = item.querySelector('.eag-form'),
          dec     = item.querySelector('.eag-dec'),
          inc     = item.querySelector('.eag-inc'),
          qty     = item.querySelector('.eag-qty-input'),
          variant = item.querySelector('.eag-variant'),
          imgEl   = item.querySelector('.eag-image-wrap img'),
          priceEl = item.querySelector('.eag-price'),
          note    = item.querySelector('.eag-bundle-note'),
          btn     = form.querySelector('button[type="submit"]');

const updatePrice = () => {
  const unit   = parseFloat(variant.selectedOptions[0].dataset.price),
        qtyVal = +qty.value || 1,
        total  = unit * qtyVal;

  // format as US currency with commas & cents
  priceEl.textContent = total.toLocaleString('en-US', {
    style:             'currency',
    currency:          'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (note) {
    note.style.display = (qtyVal >= 3 ? 'block' : 'none');
  }
};

    dec.addEventListener('click', () => { if (+qty.value>1) qty.value--; updatePrice(); });
    inc.addEventListener('click', () => { qty.value++; updatePrice(); });
    variant.addEventListener('change', () => {
      qty.value = 1; updatePrice();
      const src = variant.selectedOptions[0].dataset.image;
      if (src) imgEl.src = src;
    });

    updatePrice();

    form.addEventListener('submit', e => {
      e.preventDefault();
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          id: +variant.value,
          quantity: +qty.value
        })
      })
      .then(r => r.json())
      .then(() => {
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('theme:product:added',{bubbles:true}));
        return fetch('/cart?section_id=api-cart-items');
      })
      .then(r => r.text())
      .then(html => {
        const tmp   = document.createElement('div');
        tmp.innerHTML = html;
        const api   = tmp.querySelector('[data-api-content]');
        const cartE = document.querySelector('cart-items');
        if (cartE && api) cartE.build(api);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh',{bubbles:true}));
      })
      .catch(() => btn.disabled = false);
    });
  });

  // 2) batched Load More
  const BATCH = 18;
  const load  = document.getElementById('eag-load-more');
  if (load) {
    load.addEventListener('click', () => {
      const hidden = Array.from(document.querySelectorAll('.eag-item'))
        .filter(el => el.style.display === 'none');
      hidden.slice(0, BATCH).forEach(el => el.style.display = 'flex');
      if (hidden.length <= BATCH) load.style.display = 'none';
    });
  }
});


